import { RouteObject } from "react-router-dom";
import { lazy } from "react";

const Home = lazy(() => import("../pages/home/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
const PoolRepairPage = lazy(() => import("../pages/services/pool-repair/page"));
const SyntheticGrassPage = lazy(() => import("../pages/services/synthetic-grass/page"));
const PaversPage = lazy(() => import("../pages/services/pavers/page"));
const RoofingPage = lazy(() => import("../pages/services/roofing/page"));
const HVACPage = lazy(() => import("../pages/services/hvac/page"));
const ElectricalPage = lazy(() => import("../pages/services/electrical/page"));
const LasVegasPage = lazy(() => import("../pages/service-areas/las-vegas/page"));
const HendersonPage = lazy(() => import("../pages/service-areas/henderson/page"));
const SummerlinPage = lazy(() => import("../pages/service-areas/summerlin/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/service-areas/las-vegas",
    element: <LasVegasPage />,
  },
  {
    path: "/service-areas/henderson",
    element: <HendersonPage />,
  },
  {
    path: "/service-areas/summerlin",
    element: <SummerlinPage />,
  },
  {
    path: "/services/pool-repair",
    element: <PoolRepairPage />,
  },
  {
    path: "/services/synthetic-grass",
    element: <SyntheticGrassPage />,
  },
  {
    path: "/services/pavers",
    element: <PaversPage />,
  },
  {
    path: "/services/roofing",
    element: <RoofingPage />,
  },
  {
    path: "/services/hvac",
    element: <HVACPage />,
  },
  {
    path: "/services/electrical",
    element: <ElectricalPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
